import { render, staticRenderFns } from "./AssignRoleToUsers.vue?vue&type=template&id=11f94574&"
import script from "./AssignRoleToUsers.vue?vue&type=script&lang=js&"
export * from "./AssignRoleToUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports